// @mention helpers for the internal-note box: spot "@par" being typed at the
// caret, rank staff for it, and swap it for the chosen full name.
const nameOf = (u) => `${u.first_name || ''} ${u.last_name || ''}`.trim();

// The @-word the caret is inside, or null. A mention starts at line start or
// after whitespace, so "bob@example.com" never triggers it.
export const activeMention = (text, caret) => {
  const before = String(text).slice(0, caret);
  const match = /(^|\s)@([\w'-]*(?: [\w'-]*)?)$/.exec(before);
  if (!match) return null;
  const query = match[2];
  return { start: before.length - query.length - 1, query };
};

export const filterStaff = (staff, query, limit = 5) => {
  const q = query.trim().toLowerCase();
  return staff
    .filter((u) => nameOf(u) && (!q || nameOf(u).toLowerCase().startsWith(q)
      || String(u.last_name || '').toLowerCase().startsWith(q)))
    .slice(0, limit);
};

// Replaces the @query before the caret with "@Full Name " and reports where the caret goes.
export const insertMention = (text, mention, caret, user) => {
  const insert = `@${nameOf(user)} `;
  const next = text.slice(0, mention.start) + insert + text.slice(caret);
  return { text: next, caret: mention.start + insert.length };
};

export const staffName = nameOf;
